import axios from 'axios';
import Cookies from 'js-cookie';
import {Locale} from 'types';
import {handleRedirect} from 'utils/request/validator';

export enum ContentType {
    FORM_URLENCODED = 'application/x-www-form-urlencoded',
    JSON = 'application/json',
}

type RequestProps = {
    contentType?: ContentType;
    formData?: Record<string, unknown> | FormData;
    locale?: Locale;
    method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
    url: string;
};

export const request = ({
    contentType,
    formData,
    locale,
    method,
    url,
}: RequestProps) => {
    const headers = {
        Accept: 'application/json',
        'Active-Language': locale,
        'Content-Type': contentType,
        'X-CSRFToken': Cookies.get('csrftoken'),
        'X-MakeLeaps-Request-Source': 'UI',
        'X-MakeLeaps-Request-Tool': 'react',
    };

    return axios({
        data: formData,
        headers,
        method,
        url,
    }).then((response) => {
        if (handleRedirect(response)) return;

        return response.data.response;
    });
};
